module.exports = __webpack_public_path__ + "img/touchnj-logo.bbfe0cfe.jpg";